export enum UHFEnvironments {
    PROD = 'prod',
    PPE = 'ppe',
    INT = 'int',
    DEV = 'dev',
    NEXT = 'next'
}

export enum UHFvNowEnvironments {
    PROD = "https://uhf.microsoft.com",
    PPE = "https://uhf-ppe.microsoft.com",
    INT = "https://uhf-int.microsoft.com",
    DEV = "https://dev.onerf.microsoft.com"
}

//TODO: Update these when we have environments set up
export enum UHFvNextEnvironments {
    PROD = "https://uhf-dev.azurewebsites.net",
    PPE = "https://uhf-dev.azurewebsites.net",
    INT = "https://uhf-dev.azurewebsites.net",
    DEV = "https://uhf-dev.azurewebsites.net"
}


export enum PageFeature {
    None,
    BackPane,
    NavBar,
    ToolBar,
    Authentication,
    NavMenu,
    SettingsMenu,
    UserSettings,
    Footer,
    ChangeView,
    ErrorBoundary,
    TestPage
}

export const DefaultLocale = "en-us";
export const AustraliaLocale = "en-au";
export const UnitedStatesLocale = "en-us";
export const CanadaLocale = "en-ca";
export const UnitedKingdomLocale = "en-gb";

export const NACountryCode = "+1";
export const AustraliaCountryCode = "+61";
export const UnitedKingdomCountryCode = "+44";
export const NAPhoneMask = "(999) 999-9999";
export const AustraliaPhoneMask = "999 999 999";
export const UnitedKingdomPhoneMask = "9999 999999"
export const NAPhoneRegex = /^(\+1|)?(\d{3})(\d{3})(\d{4})$/;
export const AustraliaPhoneRegex = /^(\+61|)?(\d{3})(\d{3})(\d{3})/;
export const UnitedKingdomPhoneRegex = /^(\+44|)?(\d{4})(\d{6})/;
export const EmailRegex = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PhoneFieldRegex = /^[\d() -]{11,}$/;
export const NonNumbersRegex = /[^\d]/g;
export const InvalidCharsRegex = /[,"/\\[\]:|<>+=;?*]/g;
export const NonPrintableCharsRegex = /[^ -~]+/g;

export const NAME_MAX_CHAR = 265

export enum Themes {
    Default,
    Dark,
    HighContrast
}

export enum TextSizes {
    tiny = "tiny",
    xSmall = "xSmall",
    small = "small",
    smallPlus = "smallPlus",
    medium = "medium",
    mediumPlus = "mediumPlus",
    large = "large",
    xLarge = "xLarge",
    xxLarge = "xxLarge",
    mega = "mega"
}

export enum SortTypes {
    Alphabetical = "Alphabetical",
    Date = "Date"
}

export const Theme_Default = "theme-default";
export const Theme_Dark = "theme-dark";
export const Theme_HighContrast = "theme-highcontrast";

export const Theme_Default_Key = "default";
export const Theme_Dark_Key = "dark";
export const Theme_HighContrast_Key = "contrast";
export const Cookie_Theme = "SelectedTheme";

export enum HttpErrorCodes {
    UnAuthorized = 403,
    NotFound = 404,
    Duplicate = 409
}

export const UnAuthorizedUser = 403;
export const NotFound = 404;

export const TimeFormat = "h:mm A";
export const DateFormat = "YYYY-MM-DD";
export const DateTimeFormat = "YYYY-MM-DD hh:mm";
export const DaysInAdvance = 14;
export const TimeslotBuffer = 45;
export const TimeDiffRequirement = 10;

export enum UHFLinkType {
    XML = "xml",
    HTML = "html"
}

export const UhfTSixSecurityGroupId = "2426376d-7cd6-43d1-9648-027e7cae95c4";

export const UHFLocales = [
    "ar-ae",
    "ar-bh",
    "ar-dj",
    "ar-dz",
    "ar-eg",
    "ar-er",
    "ar-gulf",
    "ar-jo",
    "ar-iq",
    "ar-km",
    "ar-kw",
    "ar-lb",
    "ar-ly",
    "ar-ma",
    "ar-mr",
    "ar-om",
    "ar-ps",
    "ar-qa",
    "ar-sa",
    "ar-so",
    "ar-sy",
    "ar-td",
    "ar-tn",
    "ar-ww",
    "ar-ye",
    "dv-mv",
    "fa-ir",
    "ku-arab-iq",
    "pa-arab-pk",
    "prs-af",
    "ps-af",
    "sd-arab-pk",
    "syr-sy",
    "ug-cn",
    "ur-pk",
    "he-il",
    "hy-am",
    "zh-cn",
    "zh-sg",
    "zh-hk",
    "zh-mo",
    "zh-tw",
    "ba-ru",
    "be-by",
    "bg-bg",
    "kk-kz",
    "kk-tj",
    "ky-kg",
    "mk-mk",
    "mn-mn",
    "ru-by",
    "ru-kg",
    "ru-kz",
    "ru-ru",
    "ru-tj",
    "ru-tm",
    "ru-uz",
    "sa-ru",
    "sr-cyrl-ba",
    "sr-cyrl-me",
    "sr-cyrl-rs",
    "tg-cyrl-tj",
    "tt-ru",
    "uk-ua",
    "uz-cyrl-uz",
    "az-latn-az",
    "bs-ba",
    "cs-cz",
    "et-ee",
    "hr-ba",
    "hr-hr",
    "hu-hu",
    "lt-lt",
    "lv-lv",
    "pl-pl",
    "ro-md",
    "ro-ro",
    "sk-sk",
    "sl-si",
    "sr-latn-me",
    "sr-latn-rs",
    "tk-tm",
    "tr-tr",
    "as-in",
    "bn-bd",
    "bn-in",
    "gu-in",
    "hi-in",
    "kn-in",
    "kok-in",
    "ml-in",
    "mr-in",
    "ne-np",
    "or-in",
    "pa-in",
    "sa-in",
    "ta-in",
    "te-in",
    "af-za",
    "am-et",
    "arn-cl",
    "bo-cn",
    "br-fr",
    "bs-latn-ba",
    "ca-es",
    "ca-es-valencia",
    "co-fr",
    "cy-gb",
    "da-dk",
    "da-fo",
    "da-gl",
    "de-at",
    "de-ch",
    "de-de",
    "de-li",
    "de-lu",
    "dsb-de",
    "en-ae",
    "en-ai",
    "en-am",
    "en-as",
    "en-au",
    "en-aw",
    "en-bb",
    "en-bd",
    "en-bh",
    "en-ca",
    "en-cc",
    "en-ck",
    "en-cx",
    "en-cy",
    "en-dm",
    "en-eg",
    "en-et",
    "en-fj",
    "en-fk",
    "en-fm",
    "en-fo",
    "en-gb",
    "en-gd",
    "en-ge",
    "en-gg",
    "en-gh",
    "en-gi",
    "en-gm",
    "en-gu",
    "en-gulf",
    "en-gy",
    "en-hk",
    "en-id",
    "en-ie",
    "en-il",
    "en-in",
    "en-is",
    "en-je",
    "en-jm",
    "en-jo",
    "en-ke",
    "en-kh",
    "en-ki",
    "en-kn",
    "en-kw",
    "en-ky",
    "en-la",
    "en-lb",
    "en-lc",
    "en-lk",
    "en-lr",
    "en-ls",
    "en-me",
    "en-mg",
    "en-mh",
    "en-mk",
    "en-mm",
    "en-mn",
    "en-mp",
    "en-ms",
    "en-mt",
    "en-mu",
    "en-mv",
    "en-mw",
    "en-my",
    "en-na",
    "en-nf",
    "en-ng",
    "en-np",
    "en-nr",
    "en-nu",
    "en-nz",
    "en-om",
    "en-pg",
    "en-ph",
    "en-pk",
    "en-pm",
    "en-pn",
    "en-pr",
    "en-pw",
    "en-qa",
    "en-rs",
    "en-sa",
    "en-sb",
    "en-sc",
    "en-sg",
    "en-sh",
    "en-sl",
    "en-sz",
    "en-tc",
    "en-tk",
    "en-tl",
    "en-to",
    "en-tt",
    "en-tv",
    "en-tz",
    "en-ug",
    "en-us",
    "en-vc",
    "en-vg",
    "en-vi",
    "en-vu",
    "en-wf",
    "en-ws",
    "en-ww",
    "en-za",
    "en-zm",
    "en-zw",
    "es-ar",
    "es-bo",
    "es-cl",
    "es-co",
    "es-cr",
    "es-do",
    "es-ec",
    "es-es",
    "es-gq",
    "es-gt",
    "es-hn",
    "es-mx",
    "es-ni",
    "es-pa",
    "es-pe",
    "es-pr",
    "es-py",
    "es-sv",
    "es-us",
    "es-uy",
    "es-ve",
    "eu-es",
    "fi-fi",
    "fil-ph",
    "fo-fo",
    "fr-be",
    "fr-bf",
    "fr-bi",
    "fr-bj",
    "fr-ca",
    "fr-cd",
    "fr-cg",
    "fr-ch",
    "fr-ci",
    "fr-cm",
    "fr-dz",
    "fr-fr",
    "fr-ga",
    "fr-gf",
    "fr-gn",
    "fr-gp",
    "fr-ht",
    "fr-lu",
    "fr-ma",
    "fr-mc",
    "fr-ml",
    "fr-mq",
    "fr-nc",
    "fr-ne",
    "fr-pf",
    "fr-pm",
    "fr-re",
    "fr-rw",
    "fr-sn",
    "fr-td",
    "fr-tg",
    "fr-tn",
    "fr-wf",
    "fr-yt",
    "fy-nl",
    "ga-ie",
    "gd-gb",
    "gl-es",
    "gsw-fr",
    "ha-latn-ng",
    "id-id",
    "ig-ng",
    "ii-cn",
    "is-is",
    "it-ch",
    "it-it",
    "it-sm",
    "it-va",
    "kl-gl",
    "km-kh",
    "lb-lu",
    "lo-la",
    "mi-nz",
    "mn-mong-cn",
    "ms-bn",
    "ms-my",
    "mt-mt",
    "my-mm",
    "nb-no",
    "nl-be",
    "nl-nl",
    "nl-sr",
    "nn-no",
    "nso-za",
    "oc-fr",
    "pt-ao",
    "pt-br",
    "pt-cv",
    "pt-gw",
    "pt-mz",
    "pt-pt",
    "pt-st",
    "pt-tl",
    "quc-gt",
    "quc-latn-gt",
    "quz-ec",
    "quz-pe",
    "rm-ch",
    "rw-rw",
    "sb-de",
    "se-fi",
    "se-no",
    "se-se",
    "si-lk",
    "sma-no",
    "sma-se",
    "smj-no",
    "smj-se",
    "smn-fi",
    "sms-fi",
    "sq-al",
    "sv-fi",
    "sv-se",
    "sw-ke",
    "ti-et",
    "tn-za",
    "tzm-latn-dz",
    "uz-latn-uz",
    "wo-sn",
    "xh-za",
    "yo-ng",
    "zu-za",
    "ka-ge",
    "el-gr",
    "ja-jp",
    "ko-kr",
    "th-th",
    "vi-vn"
]